/**
 * Compact "Updated at" label shown in the top bar.
 * Shows the ETL sync timestamp from the backend (`/api/health` → cache_status.last_synced_at).
 * Falls back to the Finance-anchored cutoff ("Data as of 31 Aug 2026") if no sync is recorded yet.
 */
import { useEffect, useState } from "react";
import axios from "axios";

const API = process.env.REACT_APP_BACKEND_URL + "/api";

function formatSyncDate(iso) {
  if (!iso) return null;
  try {
    const d = new Date(iso);
    if (Number.isNaN(d.getTime())) return null;
    const date = d.toLocaleDateString("en-IN", { day: "2-digit", month: "short", year: "numeric" });
    const time = d.toLocaleTimeString("en-IN", { hour: "2-digit", minute: "2-digit", hour12: false });
    return `${date}, ${time} IST`;
  } catch {
    return null;
  }
}

export default function LastSyncBadge() {
  const [label, setLabel] = useState("Data as of 31 Aug 2026");

  useEffect(() => {
    let active = true;
    axios
      .get(`${API}/health`, { timeout: 8000 })
      .then((res) => {
        if (!active) return;
        const iso = res?.data?.cache_status?.last_synced_at;
        const formatted = formatSyncDate(iso);
        if (formatted) setLabel(`Updated at ${formatted}`);
      })
      .catch(() => {
        /* keep fallback label on error */
      });
    return () => {
      active = false;
    };
  }, []);

  return (
    <span
      className="text-[11px] text-red-100 font-medium tracking-wide"
      data-testid="last-sync-badge"
      title={label}
    >
      {label}
    </span>
  );
}
